import { useEffect } from "react";
import Lenis from "lenis";

// Premium inertia smooth-scroll for desktop pointers only.
// Disabled on touch / small screens and when reduced motion is preferred, because
// intercepting native touch scrolling causes janky momentum and makes the sticky
// header lag / appear "cut off" on phones.
export const useSmoothScroll = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const coarsePointer = window.matchMedia("(pointer: coarse)").matches;
    const smallScreen = window.innerWidth < 1024;
    if (reduced || coarsePointer || smallScreen) return; // native scroll on mobile/tablet

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      syncTouch: false,
    });

    let rafId = 0;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
};
